import { Outlet } from "react-router-dom";
import * as S from "./style";
//Components
import Aside from "../../components/Aside";
import Content from "../Content";
import Create from "../Modals/Order/Create";

export default function Layout() {
    return (
        <S.Container>
            <Aside />

            <S.Content>
                <Content>
                    <Outlet />
                </Content>
                <Create />
            </S.Content>
        </S.Container>
    );
}
